import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from 'src/app/_base/base.component';
import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji/public_api';
import { SocialLearningService } from 'src/app/_services';
import { PostGetResult, SocialLearningPostGet } from 'src/app/_models';
import { CommunicationsPostActions } from 'src/app/_enums';

@Component({
  selector: 'app-post-comments-viewer',
  templateUrl: './post-comments-viewer.component.html',
  styleUrls: ['./post-comments-viewer.component.scss']
})
export class PostCommentsViewerComponent extends BaseComponent implements OnInit {
  @Input()
  post: PostGetResult = null;
  @Output()
  postCommentAddedEmitter: EventEmitter<null> = new EventEmitter<null>();
  @Output()
  postCommentUpdatedEmiter: EventEmitter<PostGetResult> = new EventEmitter<PostGetResult>();
  @Output()
  postCommentDeletedEmiter: EventEmitter<null> = new EventEmitter<null>();
  userComment: string = null;
  editComment: string = null;
  isOpenedEmoji: boolean = false;
  isOpenedEditEmoji: boolean = false;
  pageSize = 5;
  pageIndex = 1;
  comments: SocialLearningPostGet = {
    results: [],
    totalRecords: 0
  };
  openedCommentId: number = null;
  constructor(private socialLearningService: SocialLearningService) {
    super();
  }

  ngOnInit() {
    this.getComments();
  }
  getUserImage(): string {
    if (localStorage.getItem('currentUser')) return this.getImage(JSON.parse(localStorage.getItem('currentUser')).profileImg);
    else return './assets/Icons/StudentsSmall.png';
  }
  getComments(): void {
    this.socialLearningService.GetComment(this.post.postId, this.pageSize, this.pageIndex).subscribe((data: SocialLearningPostGet) => {
      if (this.pageIndex === 1) {
        data.results.reverse();
        this.comments.results = data.results;
      } else data.results.map(item => this.comments.results.splice(0, 0, item));
      this.comments.totalRecords = data.totalRecords;
    });
  }
  openEmoji(): void {
    this.isOpenedEmoji = !this.isOpenedEmoji;
  }
  emojiSelection(emojiEvent: EmojiEvent): void {
    if (emojiEvent.emoji.unified !== '1F595-1F3FB') {
      if (this.userComment) this.userComment += ' ' + emojiEvent.emoji.native;
      else this.userComment = emojiEvent.emoji.native;
      this.isOpenedEmoji = false;
    }
  }
  messageSend(): void {
    this.socialLearningService
      .CreateComment({
        postId: this.post.postId,
        postItemId: this.post.postItemId,
        postItemText: this.userComment
      })
      .subscribe((data: PostGetResult) => {
        this.comments.results.push(data);
        this.comments.totalRecords += 1;
        this.postCommentAddedEmitter.emit();
        this.userComment = null;
        this.isOpenedEmoji = false;
      });
  }
  openEditEmoji(): void {
    this.isOpenedEditEmoji = !this.isOpenedEditEmoji;
  }
  editEmojiSelection(emojiEvent: EmojiEvent): void {
    if (emojiEvent.emoji.unified !== '1F595-1F3FB') {
      if (this.editComment) this.editComment += ' ' + emojiEvent.emoji.native;
      else this.editComment = emojiEvent.emoji.native;
      this.isOpenedEditEmoji = false;
    }
  }
  commentSend(commentId: number): void {
    this.socialLearningService
      .EditComment({
        postItemId: commentId,
        postItemText: this.editComment
      })
      .subscribe((data: PostGetResult) => {
        const commentIndex: number = this.comments.results.findIndex(item => item.postItemId === commentId);
        if (commentIndex !== -1) this.comments.results.splice(commentIndex, 1, data);
        this.editComment = null;
        this.isOpenedEditEmoji = false;
        this.openedCommentId = null;
      });
  }
  postAction(communicationsPostAction: number, commentId: number): void {
    if (communicationsPostAction === CommunicationsPostActions.Edit) this.postCommentEditOpen(commentId);
    else if (communicationsPostAction === CommunicationsPostActions.Delete) this.postCommentDelete(commentId);
  }
  postCommentEditOpen(commentId: number): void {
    this.openedCommentId = commentId;
    this.editComment = this.comments.results.find(item => item.postItemId === commentId).postItemText;
  }
  postCommentDelete(commentId: number): void {
    const callback = () => {
      this.socialLearningService.DeleteComment(commentId).subscribe(() => {
        const postCommentIndex = this.comments.results.findIndex(item => item.postItemId === commentId);
        if (postCommentIndex !== -1) this.comments.results.splice(postCommentIndex, 1);
        this.comments.totalRecords -= 1;
        this.postCommentDeletedEmiter.emit();
      });
    };
    this.showConfirmYesNoMessage('Common.AreYouSureYouWantToDeleteThisComment?', 'Common.DeleteComment', callback);
  }
  loadMore(): void {
    this.pageIndex += 1;
    this.getComments();
  }
  getSenderImage(imageUrl: string): string {
    return imageUrl ? this.getImage(imageUrl) : '../../assets/Images/users/default-user.jpg';
  }
}
